import { FileTextIcon } from "lucide-react";
import { Controller } from "react-hook-form";

import { TiptapEditor } from "@/components/ui/TiptapEditor";
import { useRoleAccess } from "@/features/auth/permissions/useRoleAccess.tsx";
import { CollapsibleBox } from "@/features/request/edit/components/CollapsibleBox";
import { useEditRequestFormContext } from "@/features/request/edit/hooks/useEditRequestForm";
import { useFieldUpdate } from "@/features/request/edit/hooks/useFieldUpdate";
import { useIsMBC } from "@/features/request/edit/hooks/useIsMBC";
import { useTemplateLock } from "@/features/request/edit/hooks/useTemplateLock.tsx";

export function RequestDescriptionSection() {
  const isMBC = useIsMBC();
  const { canAccess } = useRoleAccess();
  const { control } = useEditRequestFormContext();
  const { debouncedUpdateField } = useFieldUpdate();
  const { isLocked } = useTemplateLock();

  if (isMBC) return null;

  const isReadOnly =
    canAccess("edit-request.details.designer.view") || isLocked;

  return (
    <CollapsibleBox
      icon={<FileTextIcon className="text-white" size={16} />}
      iconClassName="bg-yellow-500"
      title="Request description"
    >
      <Controller
        control={control}
        name="description"
        render={({ field: { value }, fieldState: { error } }) => (
          <TiptapEditor
            className="max-h-[500px] max-w-full @container"
            errorMessage={error?.message}
            isInvalid={!!error}
            isReadOnly={isReadOnly}
            onChangeHTML={(e) => debouncedUpdateField("description", e)}
            value={value}
          />
        )}
      />
    </CollapsibleBox>
  );
}
